import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listCollection, type Row } from '../../lib/db';

export function BlogList() {
  const [rows, setRows] = useState<Row[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listCollection('blogPosts', 'createdAt').then((r) => {
      setRows(r);
      setLoading(false);
    });
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="fw-bold m-0">Blog posts</h3>
        <Link to="/blog/new" className="btn btn-success btn-sm">
          New post
        </Link>
      </div>
      {loading ? (
        <p className="text-muted">Loading…</p>
      ) : (
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Title (BG)</th>
              <th>Slug</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const title = (r.title ?? {}) as { bg?: string; en?: string };
              return (
                <tr key={r.id}>
                  <td>{title.bg || title.en || '—'}</td>
                  <td className="small text-muted">{String(r.slug ?? '')}</td>
                  <td>
                    <span className={`badge bg-${r.status === 'published' ? 'success' : 'secondary'}`}>
                      {String(r.status ?? '')}
                    </span>
                  </td>
                  <td className="text-end">
                    <Link
                      to={`/blog/${r.slug || r.id}`}
                      className="btn btn-sm btn-outline-secondary"
                    >
                      Edit
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
}
